import React from 'react'
import {
  i18nTranslate,
  jitsuSignUpRedirect,
  trackGTMEvents,
  convertToBoolean,
  isLATAM,
  isB2B2C,
} from 'src/utils'
import { Link } from 'react-router-dom'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { VscClose as CloseIcon } from 'react-icons/vsc'
import { Button, Col, ListGroup, Row } from 'react-bootstrap'
import { APPConfig, IS_BROWSER, getAppConfig } from 'config/appConfig'
import {
  application,
  getLocalStorage,
  getLocaleCodeFromUrl,
  getShoppingContext,
} from 'src/utils'
import { signInwithRedirect, signOutWithRedirect } from 'src/utils/signInUtils'
import { pageNames } from 'src/routes/pathParams'
import { customerContainer, contentStackContainer } from 'src/models'
import NuskinAccountIcon from '../../Components/UserMenu/NuskinAccountIcon'
import { MobileMenuCategories } from './MobileMenuCategories'
import NuskinLogoMobile from './NuskinLogoMobile'
import { getLocaleBasedLink } from '../staticDropDownLinks'
import { isValidUrl, enableNewFeature } from 'src/utils/commonUtils'
import MarketSelector from '../MarketLanguage/MarketSelector'
import ArrowIcon from './ArrowIcon'
import './styles.scss'
import LocaleModal from 'src/views/components/LocaleModal'
import { mobileMenuState } from 'src/views/components/Header/Components/mobileMenuState'
import { HeaderLogo } from 'src/views/components/Header/Components/HeaderLogo'
import { PageLink as PageLinks } from 'src/views/components/PageLink'

/**
 * MobileSignout component that renders the sign out button
 * in the mobile menu for authenticated users.
 * Extends React.Component.
 */
/**
 * MobileSignout component that renders the sign out button
 * in the mobile menu for authenticated users.
 * Extends React.Component.
 */
class MobileSignout extends React.Component {
  nameSpace = 'ssr-resource'
  /**
   * Toggles the mobile menu visibility when the screen size is tablet or smaller.
   */

  handleMobileMenu = () => {
    if (application.isTabletOrSmaller) {
      mobileMenuState.toggleMenuVisibility()
    } else {
      trackGTMEvents({ event: 'Signup', eventType: 'simpCustColdFormStart' })
    }
  }

  render() {
    if (!IS_BROWSER) {
      return <></>
    }

    const enableJITSU = convertToBoolean(getAppConfig()?.enableJITSU)

    const { businessRelationship } = getAppConfig()
    let pageLink = pageNames.createAccount
    if (businessRelationship === 'B2B' || isB2B2C()) {
      pageLink = pageNames.signUp
    }

    if (enableJITSU) {
      pageLink = jitsuSignUpRedirect({ isToReturnUrl: true })
    }

    let mysite
    try {
      if (typeof window !== 'undefined') {
        // const shoppingContext = getLocalStorage('shoppingContext') || {}
        // if (Object.keys(shoppingContext).length > 0) {
        // const contextValue = shoppingContext?.context || ''
        const contextValue = getShoppingContext()
        if (contextValue == 'storefront') {
          mysite = {
            display: 'none',
          }
        }
        // }
      }
    } catch (e) {
      console.error('JSON.parse may be an error SignUpForm.formInputOkta', e)
    }

    const componentToRender = customerContainer.isRegisterUser ? (
      <div
        className={`${enableNewFeature('enableNewHeaderNavigation') ? 'nu-mob-signout new-nu-mob-signout' : 'nu-mob-signout'}`}
      >
        <Button className="nu-mob-signout-btn" onClick={signOutWithRedirect}>
          {i18nTranslate('header.signOut', 'Sign Out', {
            nameSpace: this.nameSpace,
          })}
        </Button>
      </div>
    ) : (
      <div
        className={`${enableNewFeature('enableNewHeaderNavigation') ? 'nu-mob-signout new-nu-mob-signout' : 'nu-mob-signout'}`}
      >
        <Button
          // to={pageNames.signIn}
          className={`nu-mob-signout-btn`}
          onClick={signInwithRedirect}
          data-testid="qa-signin"
        >
          <NuskinAccountIcon
            className="mr-1"
            style={{ fontSize: '24px', verticalAlign: 'middle' }}
            aria-label="sign in icon"
          />
          {i18nTranslate('header.signIn', 'Sign In', {
            nameSpace: this.nameSpace,
          })}
        </Button>
        <span className="mx-1">/</span>
        {enableJITSU ? (
          <a
            href={pageLink}
            className={`nu-mob-signout-btn`}
            onClick={this.handleMobileMenu}
            data-testid="qa-signup"
            role="button"
            aria-label={i18nTranslate('header.signUp', 'Sign Up', {
              nameSpace: this.nameSpace,
            })}
            style={mysite}
          >
            {i18nTranslate('header.signUp', 'Sign Up', {
              nameSpace: this.nameSpace,
            })}
          </a>
        ) : (
          <Link
            to={pageLink}
            className={`nu-mob-signout-btn`}
            onClick={this.handleMobileMenu}
            data-testid="qa-signup"
            role="button"
            aria-label={i18nTranslate('header.signUp', 'Sign Up', {
              nameSpace: this.nameSpace,
            })}
            style={mysite}
          >
            {i18nTranslate('header.signUp', 'Sign Up', {
              nameSpace: this.nameSpace,
            })}
          </Link>
        )}
      </div>
    )

    // return ReactDOM.createPortal(
    //   componentToRender,
    //   document.getElementById('app-root')
    // )
    return componentToRender
  }
}

@observer
class MobileMenu extends React.Component {
  nameSpace = 'ssr-resource'
  @observable toggleIcon = false
  @observable currentCategoryPath = ['category']

  constructor(props) {
    super(props)
    this.mobileMenuRef = null
    this.mobilemarketSelectorRef = React.createRef()
  }

  componentDidMount() {
    document?.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount() {
    document?.removeEventListener('mousedown', this.handleClickOutside)
    this.mobileMenuRef = null
  }

  callMobileMarketFunction = () => {
    if (this.mobilemarketSelectorRef?.current?.handleShow) {
      this.mobilemarketSelectorRef.current.handleShow(true)
    }
  }

  handleClickOutside = event => {
    if (
      this.mobileMenuRef &&
      !this.mobileMenuRef?.contains(event?.target) &&
      mobileMenuState?.isMenuVisible
    ) {
      mobileMenuState?.toggleMenuVisibility()
    }
  }

  handleMenuToggle = () => {
    mobileMenuState.toggleMenuVisibility()
  }

  getJoiningLink = () => {
    const isRegisterUser = customerContainer.isRegisterUser
    return isRegisterUser ? pageNames.myaccountsubscriptions : '/signup'
  }

  handleLinkClick = () => {
    this.currentCategoryPath.splice(1)
    mobileMenuState.toggleMenuVisibility()
  }

  getCachedCategories = () => {
    const navigationData = this.props?.navigationData || {}
    if (navigationData?.categories && navigationData.categories.length > 0) {
      return navigationData.categories
    }
    return []
  }

  myFirstName = text => {
    let rtext = ''
    let len = String(text).length
    if (len > 20) {
      rtext = String(text).slice(0, 19).concat('...')
    } else {
      rtext = text
    }
    return rtext
  }

  render() {
    const accountType = getLocalStorage('accountType')
    const nu_skin_rewards_link =
      contentStackContainer.marketingData?.nu_skin_rewards
        ?.nu_skin_rewards_link || ''
    const { headerNavigation, regionSelector } = this.props
    const requestDomain = this.props?.staticContext?.requestDomain || ''
    const usdLabel = headerNavigation?.usd_label || ''
    const isMenuVisible = mobileMenuState?.isMenuVisible
    const categoriesFromMenu = this.getCachedCategories()

    let nuSkinRewardsLink = headerNavigation?.link?.href || ''
    let nuSkinRewardsTitle = headerNavigation?.link?.title || ''

    // const cookieValue = getLocalStorage('locale')
    // const finalcookieValue = cookieValue?.replace('-', '_')
    // console.log('>>>>>>>MobileMenu', mobileMenuState?.isMenuVisible)
    const enableChatWithUs =
      APPConfig?.getAppConfig()?.enableChatWithUs == 'true' || false
    const isNewHeaderEnabled =
      enableNewFeature('enableNewHeaderNavigation') ||
      enableNewFeature('enableRedesignMarketSelector') ||
      enableNewFeature('enableRedesignMainMenu')

    return (
      <div className={isNewHeaderEnabled ? 'redesign-main-menu' : ''}>
        {enableNewFeature('enableNewHeaderNavigation') && isMenuVisible && (
          <div
            className="mobile-menu-overlay"
            onClick={this.handleMenuToggle}
          />
        )}
        <aside
          ref={
            enableNewFeature('enableNewHeaderNavigation')
              ? mobileMenuRef => (this.mobileMenuRef = mobileMenuRef)
              : null
          }
          className={
            enableNewFeature('enableNewHeaderNavigation')
              ? `hide-on-desktop pancake new-pancake fixed-top nu-mobilemenu new-nu-mobilemenu ${
                  mobileMenuState.isMenuVisible ? 'open' : 'closed'
                }`
              : `hide-on-desktop pancake fixed-top w-100 h-100 bg-white nu-mobilemenu ${
                  mobileMenuState.isMenuVisible ? 'open' : 'closed'
                }`
          }
        >
          {this.currentCategoryPath.length === 1 && (
            <div
              className={`${enableNewFeature('enableNewHeaderNavigation') ? 'nu-mobilemenu-header new-nu-mobilemenu-header' : 'nu-mobilemenu-header'}`}
            >
              {enableNewFeature('enableNewHeaderNavigation') ? (
                <Row className="w-100 pt-4" noGutters>
                  <Col
                    xs={6}
                    className="text-left d-flex align-items-center justify-content-start"
                  >
                    <Link
                      to={pageNames?.home}
                      data-testid="qa-nuskin-logo-mob"
                      className="header-Logo mobile-view"
                    >
                      <HeaderLogo
                        requestDomain={requestDomain}
                        headerLogoUrl={this.props?.headerLogoUrl}
                        logoTestId="mob-img"
                        isNuskinHeader
                      />
                    </Link>
                  </Col>
                  {enableNewFeature('enableRedesignMarketSelector') &&
                  regionSelector?.countries?.length ? (
                    <Col
                      xs={6}
                      className="text-right d-flex align-items-center justify-content-end locale"
                    >
                      <span
                        className="nav-item-text"
                        aria-label="Current language and currency"
                        role="button"
                        onClick={this.callMobileMarketFunction}
                        onKeyDown={e => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault()
                            this.callMobileMarketFunction()
                          }
                        }}
                        data-testid="qa-currentLanguageCurrency"
                      >
                        {usdLabel}
                      </span>
                      <MarketSelector
                        regionSelector={regionSelector}
                        ref={this.mobilemarketSelectorRef}
                      />
                      <ArrowIcon />
                    </Col>
                  ) : null}
                </Row>
              ) : (
                <Row className="w-100 p-2 pl-3" noGutters>
                  <Col xs={11}>
                    <NuskinLogoMobile />
                    {customerContainer.isRegisterUser && (
                      <span className={`ml-3 nu-sign-text`}>
                        {i18nTranslate('header.welcome', 'Hi', {
                          nameSpace: this.nameSpace,
                        })}
                        <span> </span>
                        {this.myFirstName(
                          customerContainer.profileResponse.firstName
                        )}
                      </span>
                    )}
                  </Col>
                  <Col xs={1} className="text-right">
                    <Button
                      className="pl-0"
                      aria-label="closebutton"
                      variant="none"
                      onClick={mobileMenuState.toggleMenuVisibility}
                    >
                      <CloseIcon size="24px" />
                    </Button>
                  </Col>
                </Row>
              )}
            </div>
          )}
          <div
            className={`${enableNewFeature('enableNewHeaderNavigation') ? 'mobile-menu-container new-mobile-menu-container' : 'mobile-menu-container'}`}
          >
            <MobileMenuCategories
              {...(enableNewFeature('enableRedesignMainMenu')
                ? {
                    categories: categoriesFromMenu,
                    navigationData: this.props.navigationData,
                    currentCategoryPath: this.currentCategoryPath,
                  }
                : {
                    ...this.props,
                    currentCategoryPath: this.currentCategoryPath,
                  })}
            />
            {this.currentCategoryPath.length === 1 && (
              <ListGroup className="nu-mobilemenu-link-list">
                {enableNewFeature('enableNewHeaderNavigation')
                  ? nuSkinRewardsLink &&
                    nuSkinRewardsTitle && (
                      <ListGroup.Item>
                        <PageLinks
                          linkInfo={{ link: nuSkinRewardsLink }}
                          className="nav-item-desktop"
                          target="_blank"
                          rel="noopener noreferrer"
                          data-testid="qa-nuskinEnjoyRewardsHeader"
                        >
                          <div className="nav-item-inner">
                            <span className="nav-item-texts">
                              {nuSkinRewardsTitle}
                            </span>
                          </div>
                        </PageLinks>
                      </ListGroup.Item>
                    )
                  : isValidUrl(nu_skin_rewards_link) && (
                      <ListGroup.Item>
                        <PageLinks
                          linkInfo={{ link: nu_skin_rewards_link }}
                          className="text-decoration-none"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <span data-testid="qa-nuskinEnjoyRewards">
                            {i18nTranslate(
                              'nuskinEnjoyRewards.title',
                              'Nu Skin Rewards',
                              { nameSpace: this.nameSpace }
                            )}
                          </span>
                        </PageLinks>
                      </ListGroup.Item>
                    )}
                {enableChatWithUs && (
                  <ListGroup.Item>
                    <a
                      href={getLocaleBasedLink()}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={this.handleLinkClick}
                    >
                      {i18nTranslate('header.chat', 'Chat', {
                        nameSpace: this.nameSpace,
                      })}
                    </a>
                  </ListGroup.Item>
                )}
                {/* {this.props.data?.market?.legalLinks.map((legalLink, index) => {
              return (
                <ListGroup.Item key={index}>
                  <a
                    href={baseurl + legalLink.href}
                    onClick={this.handleLinkClick}>
                    {legalLink.name}
                  </a>
                </ListGroup.Item>
              )
            })} */}
                {!enableNewFeature('enableRedesignMarketSelector') && (
                  <ListGroup.Item>
                    <LocaleModal history={this.props.history} isNuskinHeader />
                  </ListGroup.Item>
                )}
              </ListGroup>
            )}
          </div>
          <MobileSignout />
        </aside>
      </div>
    )
  }
}

export default MobileMenu
export { MobileMenu }
